import { DateValue } from '@internationalized/date';
import { AxiosError } from 'axios';
import useSWR from 'swr';

import {
  isDefined,
  todayCentral,
  WithStatusT,
} from '@consumer-frontend/nc-utils';

import {
  apiEndpoints,
  QueryParamsT,
} from '../lib';

export type UseFullPayoffAmountPropsT = {
  accountId: string;
  loanNumber?: string;
  paymentDate?: DateValue;
};

export type UseFullPayoffAmountResponseT = {
  amount: number;
};

export const useFullPayoffAmount = ({
  accountId,
  loanNumber,
  paymentDate,
}: UseFullPayoffAmountPropsT) => {
  const queryParams: QueryParamsT = {};
  const isPaymentDateValid = isDefined(paymentDate)
    && paymentDate.compare(todayCentral()) >= 0
    && paymentDate.compare(todayCentral()) <= 35
  ;

  if (paymentDate) queryParams.as_of_date = paymentDate.toString();

  // eslint-disable-next-line @stylistic/object-curly-newline
  const { data, error, isLoading } = useSWR<WithStatusT<UseFullPayoffAmountResponseT>, AxiosError>(
    () => (isPaymentDateValid && accountId && loanNumber
      ? apiEndpoints.dashboard.fullPayoffAmount(accountId, loanNumber, queryParams)
      : null
    ),
  );

  return {
    amount: data?.amount,
    error,
    isLoading,
    status: data?.status || error?.status,
  };
};
